import * as angular from 'angular';
import { GoPage } from './go-page.service';

export const goPageModule = angular.module('go-page', [])
	.service('goPage', GoPage)
	.name;
